import * as React from 'react'
import { CalendarIcon, ChevronDownIcon } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { resolveLocale } from '@/lib/date-utils'
import { cn, formatDate } from '@/lib/utils'

type PropsType = {
  id?: string
  value?: Date
  onChange?: (date: Date | undefined) => void
  placeholder?: string
  isInvalid?: boolean
  autoFocus?: boolean
  locale?: string
}

export function DatePicker({
  id,
  value,
  onChange,
  placeholder,
  isInvalid,
  autoFocus = false,
  locale = 'en-US'
}: PropsType) {
  const dateFnsLocale = resolveLocale(locale)

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id={id}
          variant={'outline'}
          className={cn(
            'w-full justify-start text-left font-normal',
            !value && 'text-muted-foreground',
            isInvalid && 'border-destructive focus-visible:ring-destructive'
          )}>
          <CalendarIcon className="h-4 w-4 shrink-0" />
          <span className="flex-1">
            {value ? (
              formatDate(value, locale)
            ) : (
              <span className="text-muted-foreground">{placeholder ?? 'Pick a date'}</span>
            )}
          </span>
          <ChevronDownIcon className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value}
          defaultMonth={value}
          onSelect={onChange}
          autoFocus={autoFocus}
          captionLayout="dropdown"
          startMonth={new Date(1900, 0)}
          endMonth={new Date(new Date().getFullYear(), 11)}
          locale={dateFnsLocale}
        />
      </PopoverContent>
    </Popover>
  )
}
